import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../lib/api';

/**
 * Fires a /api/track/view on route change. Non-blocking; failures ignored.
 */
export default function PageTracker() {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    let kind = null;
    let product_id = null;
    if (location.pathname === '/catalog') kind = 'catalog';
    else if (location.pathname.startsWith('/product/')) {
      kind = 'product';
      product_id = location.pathname.split('/').pop();
    }
    if (!kind) return;
    api.post('/track/view', { kind, product_id, lang: i18n.language, referrer: document.referrer || '' })
      .catch(() => {});
  }, [location.pathname, i18n.language]);

  return null;
}
